import { Add01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { useI18n } from '@pique/i18n';

import { ExplorerEmptySection } from '../../layouts/empty-section';

export const RootEmpty = ({
  onClickCreate,
}: {
  onClickCreate?: () => void;
}) => {
  const t = useI18n();

  return (
    <ExplorerEmptySection
      icon={<HugeiconsIcon icon={Add01Icon} size={14} strokeWidth={2} />}
      message={t['com.pique.collections.empty.message']()}
      messageTestId="slider-bar-collection-empty-message"
      onActionClick={onClickCreate}
    />
  );
};
